module.exports = __webpack_public_path__ + "img/baojia1.749de351.png";